"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Backdrop_1 = __importDefault(require("@material-ui/core/Backdrop"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles({
    blur: {
        backdropFilter: 'blur(10px)',
        zIndex: 1,
    },
});
var Backdrop = react_1.forwardRef(function Backdrop(_a, ref) {
    var _b;
    var children = _a.children, _c = _a.invisible, invisible = _c === void 0 ? false : _c, classes = _a.classes, open = _a.open, _d = _a.transitionDuration, transitionDuration = _d === void 0 ? 200 : _d, className = _a.className, _e = _a.blur, blur = _e === void 0 ? false : _e, rest = __rest(_a, ["children", "invisible", "classes", "open", "transitionDuration", "className", "blur"]);
    var privateClasses = useStyles();
    return (jsx_runtime_1.jsx(Backdrop_1.default, __assign({ classes: classes, className: classnames_1.default(className, (_b = {},
            _b[privateClasses.blur] = blur,
            _b)), invisible: invisible, open: open, transitionDuration: transitionDuration, ref: ref }, rest, { children: children }), void 0));
});
exports.default = Backdrop;
//# sourceMappingURL=Backdrop.js.map